import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export type BarPointRange = { start: Date; end: Date };

const addMonths = (date: Date, monthsToAdd: number) => {
  const d = new Date(date.getTime());
  d.setDate(1);
  d.setMonth(d.getMonth() + monthsToAdd);
  return d;
};

const startOfMonth = (date: Date) => {
  const d = new Date(date.getFullYear(), date.getMonth(), 1);
  d.setHours(0, 0, 0, 0);
  return d;
};

const endOfMonth = (date: Date) => {
  const d = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  d.setHours(23, 59, 59, 999);
  return d;
};

const startOfYear = (date: Date) => {
  const d = new Date(date.getFullYear(), 0, 1);
  d.setHours(0, 0, 0, 0);
  return d;
};

const endOfYear = (date: Date) => {
  const d = new Date(date.getFullYear(), 11, 31);
  d.setHours(23, 59, 59, 999);
  return d;
};

export const getBarPointDateRange = (
  baseStart: Date | string | undefined,
  index: number,
  frequency: WintSuperkollAPIModel.ReportWidgetDataFrequency | undefined
): BarPointRange | undefined => {
  if (!baseStart || frequency === undefined) return undefined;

  const baseDate = new Date(baseStart);

  if (frequency === WintSuperkollAPIModel.ReportWidgetDataFrequency.Monthly) {
    const pointDate = addMonths(baseDate, index);
    return { start: startOfMonth(pointDate), end: endOfMonth(pointDate) };
  }

  if (frequency === WintSuperkollAPIModel.ReportWidgetDataFrequency.Daily) {
    const d = new Date(baseDate.getTime());
    d.setDate(d.getDate() + index);
    d.setHours(0, 0, 0, 0);
    const dEnd = new Date(d.getTime());
    dEnd.setHours(23, 59, 59, 999);
    return { start: d, end: dEnd };
  }

  if (frequency === WintSuperkollAPIModel.ReportWidgetDataFrequency.Yearly) {
    const y = baseDate.getFullYear() + index;
    const yDate = new Date(y, 0, 1);
    return { start: startOfYear(yDate), end: endOfYear(yDate) };
  }

  const pointDate = addMonths(baseDate, index);
  return { start: startOfMonth(pointDate), end: endOfMonth(pointDate) };
};
